import { queryOptions } from "@tanstack/react-query";
import { listRetailPacksFn } from "./retail.functions";

export const retailPacksQuery = () =>
  queryOptions({
    queryKey: ["retail", "packs"],
    queryFn: () => listRetailPacksFn(),
    staleTime: 60_000,
  });